import LabelFormView from "./LabelFormView";

function LabelForm({ printerData, setPrinterData, submitError }) {
  /**
   * This method will handle the label width change
   * @param {event} e
   */
  function onLabelWidthChange(e) {
    setPrinterData((prev) => ({
      ...prev,
      label_width: e.target.value,
    }));
  }

  /**
   * This method will handle the label height change
   * @param {event} e
   */
  function onLabelHeightChange(e) {
    setPrinterData((prev) => ({
      ...prev,
      label_height: e.target.value,
    }));
  }

  return (
    <LabelFormView
      printerData={printerData}
      onLabelWidthChange={onLabelWidthChange}
      onLabelHeightChange={onLabelHeightChange}
      submitError={submitError}
    />
  );
}

export default LabelForm;
